import ApprentiPrenom from '@/generated/controls/apprenti/ApprentiPrenom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ApprentiPrenom
})
